import { Component, inject, input, OnInit } from '@angular/core';
import { NgbModalRef, NgbTimepicker } from '@ng-bootstrap/ng-bootstrap';
import { DialogAction } from '@features/dashboard/components/alert/enums/dialogAction';
import { Shift } from '@interfaces/data/shift';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CancelBtn } from '../../../../cancel-btn/cancel-btn.component';
import { SaveBtn } from '../../../../save-btn/save-btn.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-code-modal',
  standalone: true,
  templateUrl: './edit-shift-modal.component.html',
  styleUrl: './edit-shift-modal.component.scss',
  imports: [
    ReactiveFormsModule,
    NgbTimepicker,
    CancelBtn,
    SaveBtn,
    TranslateModule,
  ],
})
export class EditShiftModalComponent implements OnInit {
  shiftForm!: FormGroup;
  shift = input.required<Shift>();
  modalRef = input.required<NgbModalRef>();
  private fb = inject(FormBuilder);

  ngOnInit(): void {
    this.shiftForm = this.fb.group({
      startTime: this.shift().startTime ?? {
        hour: 5,
        minute: 0,
      },
      endTime: this.shift().endTime ?? {
        hour: 8,
        minute: 0,
      },
      shiftNumber: this.shift().shiftNumber ?? '1',
      department:
        this.shift().department ?? '',
      id: this.shift().id,
    });
  }

  handleCancel() {
    this.modalRef().close(DialogAction.CANCEL);
  }

  handleSubmit() {
    const shift: Shift = this.shiftForm.getRawValue();
    this.modalRef().close({
      action: DialogAction.SUBMIT,
      payload: shift,
    });
  }
}
